<template>
  <div class="auth-page">
    <div class="background-image">
      <img src="/images/car.jpeg" alt="LGA logo" />
    </div>
    <div class="auth-sidebar" id="auth-sidebar">
      <div class="auth-container">
        <div class="logo text-center">
          <img src="/images/lga-logo.png" alt="LGA Logo" />
        </div>
        <hr />
        <h1>Reset Password</h1>
        <p>Please enter a new password below.</p>

        <div class="alert alert-danger" v-if="form.errors.has('email')">
          <h4>Error!</h4>
          <p>Sorry, the following errors occurred:</p>
          <ul>
            <li
              v-bind:key="index"
              v-for="(error, index) in form.errors.all()"
              v-text="error[0]"
            ></li>
          </ul>
        </div>

        <form>
          <div class="row">
            <inputbox
              :stacked="false"
              label="Email Address"
              v-model="form.email"
              :readonly="true"
            ></inputbox>

            <inputbox
              name="password"
              :stacked="false"
              label="New Password"
              placeholder="New Password"
              v-model="form.password"
              type="password"
              :show-error="form.errors.has('password')"
              :error-message="form.errors.get('password')"
            ></inputbox>

            <inputbox
              name="password_confirmation"
              :stacked="false"
              label="Confirm New Password"
              placeholder="Confirm New Password"
              v-model="form.password_confirmation"
              type="password"
              :show-error="form.errors.has('password_confirmation')"
              :error-message="form.errors.get('password_confirmation')"
            ></inputbox>
          </div>

          <div class="row">
            <div class="col-lg-6">
              <form-button
                :indicator="indicator"
                level="primary"
                v-on:clicked="request"
                >Reset Password</form-button
              >
            </div>
            <div class="col-lg-6"></div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Form from './../../Classes/Form';

export default {
  data() {
    return {
      form: new Form(
        {
          token: this.$route.query.token,
          email: this.$route.query.email,
          password: null,
          password_confirmation: null
        },
        false
      ),
      completed: false,
      indicator: false
    };
  },

  mounted() {
    new window.Ps(document.getElementById('auth-sidebar'));
  },

  methods: {
    request() {
      this.indicator = true;

      this.form
        .post('/reset-password')
        .then(response => {
          this.handleSuccessResponse(response);
        })
        .catch(error => {
          this.handleFailedResponse(error);
        });
    },

    handleSuccessResponse(response) {
      this.completed = true;
      this.disableIndicator();

      window.toastify.success(
        'Success!',
        'Your password was reset successfully'
      );

      this.$router.push('/login');
    },

    handleFailedResponse(error) {
      if (error.error == 'Invalid credentials') {
        window.toastify.error('Sorry, there was an issue making the request');
      }

      this.disableIndicator();
    },

    disableIndicator() {
      this.indicator = false;
    }
  }
};
</script>
